export const getCoupon = coupon => ({
    type: 'GET_COUPON',
    coupon
  })